import React, { Component } from "react";
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";

import { Grid, Row, Col, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { selectOrder, exportDatafile } from "../../redux/actions";
import PersianDate from "persian-date";
import { PersianNumber } from "@thg303/react-persian";
const mapStateToProps = (state) => {
  return {
    selectedOrder: state.selectedOrder,
    selectedCustomer: state.selectedCustomer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectOrder: (order) => {
      dispatch(selectOrder(order));
    },
    exportDatafile: () => {
      dispatch(exportDatafile());
    },
  };
};

class OrderList extends Component {
  constructor(props) {
    super(props);
    this.viewOrder = this.viewOrder.bind(this);
  }

  componentDidMount() {
    this.props.exportDatafile();
  }

  viewOrder() {
    return "/singleOrder";
  }

  render() {
    return (
      <div>
        <Row>
          <Col xs={12} md={12}>
            <div className="title-header">سفارش‌ها</div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}>
            <ReactTable
              className="-striped -highlight"
              filterable
              data={this.props.selectedCustomer.orders}
              showPagination={true}
              showPaginationBottom={true}
              showPageSizeOptions={true}
              pageSizeOptions={[5, 10, 20, 25, 50, 100]}
              defaultPageSize={20}
              showPaginationTop={false}
              columns={[
                {
                  columns: [
                    {
                      Header: "شماره",
                      accessor: "id",
                      Cell: (original) => (
                        <PersianNumber>{original.original.id}</PersianNumber>
                      ),
                    },
                    {
                      Header: "تاریخ",
                      // id: 'stringDate',
                      // accessor: (row) =>  row.stringDate
                      accessor: "stringDate",
                      Cell: (original) => {
                        return new PersianDate(
                          new Date(original.original.created)
                        ).format();
                      },
                    },
                    {
                      Header: "شماره صنفی",
                      accessor: "senfi_number",
                      Cell: (original) => (
                        <PersianNumber>
                          {original.original.code_senfi}
                        </PersianNumber>
                      ),
                    },
                    {
                      Header: "شماره فاکتور",
                      accessor: "invoice_number",
                      Cell: (original) => (
                        <PersianNumber>
                          {original.original.invoice_number}
                        </PersianNumber>
                      ),
                    },
                    {
                      Header: "آدرس",
                      accessor: "address",
                    },
                    {
                      Header: "قیمت نهایی",
                      accessor: "total_price",
                      Cell: (original) => (
                        <PersianNumber>
                          {original.original.total_price}
                        </PersianNumber>
                      ),
                    },
                  ],
                },
                {
                  Header: "مشاهده",
                  accessor: "progress",
                  filterable: false,
                  Cell: (original) => (
                    <NavLink to={this.viewOrder()}>
                      <i
                        onClick={() =>
                          this.props.selectOrder(original.original)
                        }
                        className="view-customer"
                      >
                        مشاهده
                      </i>
                    </NavLink>
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const OrderListConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderList);

export default OrderListConnect;
